import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题

import elementZh from 'element-ui/lib/locale/lang/zh-CN'
import elementEn from 'element-ui/lib/locale/lang/en'
import elementTh from 'element-ui/lib/locale/lang/th'
import elementKm from 'element-ui/lib/locale/lang/km'

import zhCN from './lang/zh-CN'
import en from './lang/en'
import th from './lang/th'
import km from './lang/km'

Vue.use(VueI18n)

const Languages = {
  'zh-CN': '简体中文',
  'en': 'English',
  'th': 'ภาษาไทย',
  'km': 'កម្ពុជា'
}
const messages = {
  'zh-CN': {
    ...elementZh,
    ...zhCN,
  },
  'en': {
    ...elementEn,
    ...en,
  },
  'th': {
    ...elementTh,
    ...th,
  },
  'km': {
    ...elementKm,
    ...km,
  }
}

let webLanguage = navigator.language; // 获取浏览器默认语言
if (webLanguage.indexOf('en') === 0) {
  webLanguage = 'en';
} else if (webLanguage.indexOf('th') === 0) {
  webLanguage = 'th';
} else if (webLanguage.indexOf('km') === 0) {
  webLanguage = 'km';
} else {
  webLanguage = 'zh-CN';
}
const LANGUAGE = Vue.prototype.$language = localStorage.getItem('main_language') || webLanguage;

let locale = localStorage.getItem('language') || LANGUAGE;
if (!messages[locale]) {
  // 防止存储的language在messages中无定义
  locale = ([LANGUAGE] ? LANGUAGE : webLanguage)
}
const i18n = new VueI18n({
  locale,
  messages
})
localStorage.setItem('language', i18n.locale)

Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})

// const Currency = {
//   'zh-CN': '元',
//   'en': '美元',
//   'th': '铢',
//   'km': '瑞尔'
// }; // 语言单位
const languageCurrency = {
  'zh-CN': 'CNY',
  'en': 'USD',
  'th': 'SGD',
  'km': 'KHR',
}; // 语言对于货币
const CurrencyObj = {
  'CNY': '{num}元',
  'CNY-2': '￥{num}',
  'USD': '${num}',
  'SGD': 'S${num}',
  'THB': '฿{num}',
  'KHR': '៛{num}',
  'EUR': '€{num}',
  'GBP': '￡{num}',
  'JPY': 'J￥{num}',
  'HKD': 'HK${num}',
  'VND': '₫{num}',
  'RUB‌': '₽{num}',
  'INR': '₹{num}',
}; // 货币单位对应 翻译

function initCurrencyData(unit) {
  const currencyStr = CurrencyObj[unit];
  const currencyArr = currencyStr ? currencyStr.split('{num}') : ['', '']; //用翻译切割分为前缀和后缀
  Vue.prototype.$CurPrefix = currencyArr[0]; //货币单位前缀
  Vue.prototype.$CurSuffix = currencyArr[1]; //货币单位后缀
  Vue.prototype.$currencyUnit = unit;
  localStorage.setItem('currencyUnit', unit)
}

Vue.prototype.$languageCurrency = languageCurrency; // 语言对应默认货币
Vue.prototype.$currencyList = Object.keys(CurrencyObj); // 货币列表
Vue.prototype.$CurrencyObj = CurrencyObj; // 货币单位对应翻译
let currencyUnit = localStorage.getItem('currencyUnit') || languageCurrency[LANGUAGE] || 'CNY'; // 当前货币

Vue.prototype.initCurrencyData = initCurrencyData;
initCurrencyData(currencyUnit)

let $bus = '';

function initTranslation(key, data, isTl = false, unit) {
  if (!key) {
    return ''
  }
  if (!$bus) {
    $bus = Vue.prototype.$bus;
  }

  // // 对主语言单位做翻译处理
  // if (key == '元' && Currency[$bus.$language]) {
  //   key = Currency[$bus.$language];
  // } else if (key.indexOf('yuan') != -1) {
  //   data.yuan = $bus.$t(Currency[$bus.$language]);
  // }

  // return isTl ? $bus.$t(key, $bus.$language, data) : $bus.$t(key, data);

  // 货币机制 翻译单独处理
  if (!unit) {
    unit = $bus.$currencyUnit;
  }
  // 对'{num}元'货币翻译
  if (key == '{num}元') {
    key = CurrencyObj[unit];
    return key.replace('{num}', data.num)
  }
  // 当前已减{num1}{yuan}，还差{num2}{yuan}可减{num3}{yuan} 重新赋值 data中num1、num2等这类参数 S${xxx}
  if (key.indexOf('}{yuan}') != -1) {
    key.replace(/(\{(.{0,8})\}\{yuan\})/g, function(val, replacer, $1) {
      data[$1] = CurrencyObj[unit].replace('{num}', data[$1])
      return val
    })
  }
  data.yuan = '{yuan}';
  let str = isTl ? $bus.$t(key, $bus.$language, data) : $bus.$t(key, data);
  if (key.indexOf('$SPLIT${yuan}') != -1) {
    // 翻译后 对$SPLIT${yuan}这类翻译特殊处理 并将多余的{yuan}移除
    let replaceStr = CurrencyObj[unit].replace('{num}', ' $SPLIT$');
    str = str.replace(/(\$SPLIT\$\{yuan\})/g, replaceStr)
  }
  return str.replace(/(\{yuan\})/g, '')
}
// 设置$tl翻译使用主语言
Vue.prototype.$tl = function(key, data = {}, unit = '') {
  return initTranslation(key, data, true, unit)
}
Vue.prototype.$ts = function(key, data = {}, unit = '') {
  return initTranslation(key, data, unit)
}

export {
  i18n,
  Languages
}



// WEBPACK FOOTER //
// ./src/locale/index.js